import {useQuery} from "@tanstack/react-query"
import axios from "axios"
import {AutomationSearchResult} from "../types/Automations";

interface UseAutomationUpdateQueryProps {
    companyAutomationId: number
}

export default function useAutomationUpdateQuery({
    companyAutomationId,
}: UseAutomationUpdateQueryProps) {
    return useQuery({
        queryKey: ['updateAutomation', companyAutomationId],
        queryFn: async () => {
            if (companyAutomationId === 0) return null;
            const GET_AUTOMATION_UPDATE_ENDPOINT = '/admin/action/automation/admin/fullDetails';
            const { data } = await axios.get(GET_AUTOMATION_UPDATE_ENDPOINT, {
                params: {
                    companyAutomationId
                }
            })
            const automation = data.COMPANY_AUTOMATIONS;
            return automation as AutomationSearchResult;
        },
    })
}